import { createRouter, createWebHistory } from 'vue-router'
import GtoSettingView from '../views/gto-setting/GTOSettingView.vue'
import UnauthorizedView from '../views/UnauthorizedView.vue'
import LoginView from '../views/LoginView.vue'
import LivenEngageLogsView from '../views/LivenEngage/LivenEngageLogsView.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    beforeEnter: (to, from, next) => {
      const token = localStorage.getItem('token');
      if (token) {
        next('/gto-setting');
      } else {
        next('/login');
      }
    }
  },
  {
    path: '/unauthorized',
    name: 'unauthorized',
    component: UnauthorizedView
  },
  {
    path: '/login',
    name: 'login',
    component: LoginView
  },

  {
    path: '/gto-setting',
    name: 'gto-setting',
    component: GtoSettingView,
    meta: { requiresAuth: true }
  },
  {
    path: '/liven-engage-logs',
    name: 'livenEngageLogs',
    component: LivenEngageLogsView,
    meta: { requiresAuth: true }
  }
]

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes
})

router.beforeEach((to, from, next) => {
  // Check if there's a token in the URL query parameters
  const token = to.query.token;
  if (token) {
    localStorage.setItem('token', token);
    
    // Remove the token from the URL
    next({ path: to.path, query: {} });
    return;
  }

  if (to.meta.requiresAuth && !localStorage.getItem('token')) {
      next('/login');
  } else {
    next();
  }
})

export default router 